module.exports = __webpack_public_path__ + "static/img/basic-notext.74d9acb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/basic-notext.png
// module id = bdq+
// module chunks = 1